<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style" id="fm-04-maintoc-epub-text">
<h1 class="chapter-heading" id="toc-anchor" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace">what's inside</h1>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><a href="#/Text/FM_05_AllAboutIcePops_text">all about ice pops</a></p>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span href="#/Text/CH01_00_TOC_ePub_image" title="Link target outside of Sample">fruity ice pops</span></p>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span href="#/Text/CH02_00_TOC_ePub_image" title="Link target outside of Sample">chocolate ice pops</span></p>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span href="#/Text/CH03_00_TOC_ePub_image" title="Link target outside of Sample">creamy ice pops</span></p>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span href="#/Text/CH04_00_TOC_ePub_image" title="Link target outside of Sample">new flavors for ice pops</span></p>
<p class="toc-recipe" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span href="#/Text/BM_00_CreativeShapes_text" title="Link target outside of Sample">creative shapes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM_04_MainTOC_ePub_text.vue?73eaa70c